import { createContext, useContext } from "react";

const context = createContext({
	initialAction: null,
	currentAction: null,
	isOpen: false,
	changeCurrentAction: () => {},
	open: () => {},
	close: () => {},
	toggle: () => {},
	settings: {},
	containerRef: () => {},
});

export const useDropDown = () => useContext(context);

export default context;
